import { _ep0, _mw13, command } from "../commandBuilder";
import { UploadPart$ } from "../schemas/schemas_0";
export class UploadPartCommand extends command(_ep0, _mw13, "UploadPart", UploadPart$) {
}
